module.exports = __webpack_public_path__ + "img/488.7cc791f4.png";